
import React from "react";
import PersonIcon from '@mui/icons-material/Person';
import DataThresholdingIcon from '@mui/icons-material/DataThresholding';
import DatasetOutlinedIcon from '@mui/icons-material/DatasetOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PeopleIcon from '@mui/icons-material/People';

export const resistanceDataPage = "Resistance Data";
export const dashboardPage = "Dashboard";
export const dataManVocabPage = "Manage Vocabulary";
export const dataManResDataPage = "Manage Resistance Data";
export const userManagementPage = "User Management";
export const editActionId = 'edit_action_id'
export const deleteActionId = 'delete_action_id'
export const uploadPage = "Upload Resistance Data";
export const profilePage = "Profile";

export const pageToUrlName = {
    [dashboardPage]: "dashboard",
    [resistanceDataPage]: "resistance_data",
    [dataManVocabPage]: "data_management_vocabulary",
    [dataManResDataPage]: "data_management_resistance_data",
    [uploadPage]: "upload_resistance_data",
    [userManagementPage]: "users",
    [profilePage]: "profile",
};

export const pageToNeedsAdmin = {
    [dashboardPage]: false,
    [resistanceDataPage]: false,
    [dataManVocabPage]: true,
    [dataManResDataPage]: true,
    [uploadPage]: true,
    [userManagementPage]: true,
    [profilePage]: false,
};

export var pages = [
    resistanceDataPage,
    dashboardPage,
    dataManVocabPage,
    dataManResDataPage,
    uploadPage,
    userManagementPage,
    profilePage,

];

export var pageToicon = {
    [dashboardPage]: <SpeedOutlinedIcon />,
    [resistanceDataPage]: <DescriptionOutlinedIcon />,
    [userManagementPage]: <PeopleIcon />,
    [dataManVocabPage]: <DatasetOutlinedIcon />,
    [uploadPage]: <CloudUploadIcon />,
    [dataManResDataPage]: <DataThresholdingIcon />,
    [profilePage]: <PersonIcon />
};

export function urlToPageName(url) {
    return Object.keys(pageToUrlName).find(key => pageToUrlName[key] === url);
}